// extracted by mini-css-extract-plugin
module.exports = {"container":"ProgressDots_container__1jAXH","dot":"ProgressDots_dot__1KfXv","current":"ProgressDots_current__2bg6e"};